import KeyValuePair from '@/modules/core/support/KeyValuePair';
import UserGroup from '@/modules/user/model/UserGroup';
import ApiVersion from '@/modules/app-router/model/ApiVersion';
import moment from 'moment';
import ReleaseChange from '@/modules/app-router/model/ReleaseChange';

/**
 * Distribución de la aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class AppRelease {
    public id = 0
    public name = ''
    public version = ''
    public path = ''
    public default = false
    public distFile: File | null = null
    public userGroups: UserGroup[] = []
    public apiVersion = new ApiVersion()
    public createdAt = new Date()
    public updatedAt = new Date()
    public enabled = true
    public changelog = ''
    public distPath = ''

    /**
     * Cambios realizados sobre la distribución publicada
     *
     * @var { ReleaseChange[] }
     */
    public changes: ReleaseChange[] = []

    public get isNew () {
        return !this.id
    }

    /**
     * Crea una entidad a partir de la información obtenida de la API
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const release = Object.assign(new this(), {
            id: data.id,
            version: data.version,
            distPath: data.dist_path || '',
            userGroups: data.user_groups.map((g: KeyValuePair) => UserGroup.deserialize(g)),
            apiVersion: data.api_version ? ApiVersion.deserialize(data.api_version) : new ApiVersion(),
            createdAt: moment(data.created_at, 'DD/MM/YYYY HH:mm:ss').toDate(),
            updatedAt: moment(data.updated_at, 'DD/MM/YYYY HH:mm:ss').toDate(),
            default: data.default || false,
            enabled: data.enabled,
            changelog: data.changelog || '',
        })

        if (Array.isArray(data.changes)) {
            release.changes = data.changes.map((c: KeyValuePair) => ReleaseChange.deserialize(c))
        }

        return release
    }

    public serialize () {
        return {
            version: this.version,
            name: this.name,
            default: this.default,
            api_version: this.apiVersion.id,
            user_groups: this.userGroups.map(g => g.id),
            enabled: this.enabled,
            changelog: this.changelog,
            changes: this.changes.map(c => c.serialize()),
        }
    }
}
